const AddCartIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_836_6309)">
        <path
          d="M13.6035 15.6797V30.2776"
          stroke="#B4B2B5"
          strokeWidth="1.5"
          strokmiterlimit="10"
        />
        <path
          d="M0.962891 8.38281L13.605 15.6818L26.2472 8.38281"
          stroke="#B4B2B5"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M26.2472 19.1189V8.38094L13.605 1.08203L0.962891 8.38094V22.9788L13.605 30.2778L19.3006 26.9895"
          stroke="#1A0425"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M25.008 31.063C28.3413 31.063 31.0434 28.3608 31.0434 25.0276C31.0434 21.6943 28.3413 18.9922 25.008 18.9922C21.6748 18.9922 18.9727 21.6943 18.9727 25.0276C18.9727 28.3608 21.6748 31.063 25.008 31.063Z"
          stroke="#1A0425"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M25.0039 22.0469V28.0073"
          stroke="#B4B2B5"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M27.9858 25.0273H22.0254"
          stroke="#B4B2B5"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_836_6309">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AddCartIcon;
